import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//get compnay data
export const comapnyListService = createAsyncThunk(
  "comapny/list",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/admin/companies?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get comapny by id
export const comapnyGetByid = createAsyncThunk(
  "comapny/compnaybyid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users/company`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//update compnay
export const Updatecomapny = createAsyncThunk(
  "comapny/updatedata",
  async ({ id, data }, { rejectWithValue }) => {
    console.log(id, data);
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/admin/companies/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//delete compnay by id
export const deletecomapny = createAsyncThunk(
  "comapny/delete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/admin/companies/${data}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get comapny by id admin
export const adminComapnyGetByid = createAsyncThunk(
  "comapny/admincompnaybyid",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/users/company-admins?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//company status chnage
export const companyStatus = createAsyncThunk(
  "company/updatedstatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `users/company/status`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//company list admin status
export const companyAdminStatus = createAsyncThunk(
  "company/updatedadminstatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/users/${id}/status`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//update company details from company page
export const updateCompanydetails = createAsyncThunk(
  "company/updatedcompanydetils",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/admin/companies/${id}`, //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//whole company delete
export const companyDelete = createAsyncThunk(
  "company/deleteCompany",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/admin/companies/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
